import { Injectable } from '@angular/core';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class MomentFormatterService {
  dateOnly(date: moment.Moment): string {
    return date.format("YYYY-MM-DD");
  }

  dateAndTime(date: moment.Moment): string {
    return date.format("YYYY-MM-DD HH:mm:ss");
  }
}
